import { HttpParams } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../../../../shared/services/commom.service';
import { DatatableService } from '../../../../../shared/services/datatable.service';
import { EncriptyUtilService } from '../../../../../shared/services/encripty-util.service';
import { ExportCsvService } from '../../../../../shared/services/export-csv.service';
import { ImportCsvService } from '../../../../../shared/services/import-csv.service';
import { CPFValidator } from '../../../../../shared/validators/CPFValidator';
import { DateValidator } from '../../../../../shared/validators/DateValidator';
import { EmailValidator } from '../../../../../shared/validators/EmailValidator';
import { NumberValidator } from '../../../../../shared/validators/NumberValidator';
import { PhoneValidator } from '../../../../../shared/validators/PhoneValidator';
import { ModalPrimeiraViaComponent } from '../../modal-primeira-via/modal-primeira-via.component';
import { ImportacaoFuncionariosService } from './importacao-funcionarios.service';
import { ModalEmissaoCartaoComponent } from './modal-emissao-cartao/modal-emissao-cartao.component';

declare var $: any;

@Component({
  selector: 'ngx-importacao-funcionarios',
  templateUrl: './importacao-funcionarios.component.html',
  styleUrls: ['./importacao-funcionarios.component.scss'],
})
export class ImportacaoFuncionariosComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput', null) fileInput;
  @ViewChild('fileLabel', null) fileLabel;
  @ViewChild('myTable', null) private myTable: DatatableComponent;

  public idProdutoSelected = null;
  public productCardInfo = [];
  public isPagamento: boolean = false;
  public hasVarejoAccepted: boolean = false;
  public exibeSaldos: boolean = false;  //isPagamento && hasVarejoAccepted

  public saldoGlobalDisp = null;
  public saldoContaDisp = null;
  public saldoProx30diasDisp = null;
  public saldoParceladoDisp = null;
  public percMaximoReuso = null;

  public taxaEmissao = null;
  public tarAgiliza = null;

  public resultadoSaldoAgiliza = null;

  public isDisabledSaveButton: boolean = true;
  public isProdutoMigrado: boolean = false;
  public isValidImportCsv: boolean = false;
  public importValuesForm: FormGroup = null;

  public valorImportado = null;
  public valorSolicitado = null;
  public listBandeiras: any = [];
  listBandeirasSelecionadas: Array<any> = [];

  public msgErroSaldos = "";
  public msgErroImport = 'Dado(s) inválido(s) encontrado(s) no arquivo. Favor corrigir, no arquivo, os erros em destaque.';
  public showMsgErroImport = false;
  public empresaCnpj = null
  public subTitle = 'Realize o cadastro de funcionário já solicitando a 1ª via do cartão.';

  private modeloImportacao = [{
    nome: 'NOME_FUNCIONARIO',
    cpf: '00000000000',
    cargo: 'CARGO_FUNCIONARIO',
    matricula: 'MATRICULA_FUNCIONARIO',
    data_admissao: '01/02/2020',
    telefone_celular: '00 000000000',
    email: 'E@MAIL.COM',
    salario: '1200,50',
    nome_social: 'NOME_SOCIAL',
    data_nascimento: '01/02/2020',
    nome_mae: 'NOME_MAE',
  }];

  public listOptEmissaoCartao = null;

  rowData = [];
  columnData = [];
  public customLogin = null;
  public idProduct = null;
  public check = false;
  public importCsv = null;

  constructor(
    private notifications: NotificationsService,
    private service: ImportacaoFuncionariosService,
    private router: Router,
    private datatableService: DatatableService,
    private commomService: CommonService,
    private exportCsvService: ExportCsvService,
    private importCsvService: ImportCsvService,
    private spinnerService: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private encriptyService: EncriptyUtilService,
    private dialogService: NbDialogService,
  ) {

    this.importValuesForm = this.formBuilder.group({
      saldoGlobal: [null],
      saldoConta: [null],
      saldoProx30dias: [null],
      saldoParcelado: [null],
      saldo30dias: [null],
      valorImportado: [null],
      valorSolicitado: [null],
      saldoAgiliza: [null],
      emissaoCartao: [null],
      bandeira: [null]
    });

    this.listOptEmissaoCartao = [
      {
        descricao: 'SIM',
        valor: 'S'
      },
      {
        descricao: 'NÃO',
        valor: 'N'
      },
    ];

  }

  ngOnInit() {

    this.verificarMigracaoRollout();

    this.idProduct = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);
    this.empresaCnpj = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'));
    this.idProdutoSelected = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));

    let params = new HttpParams();
    if (this.empresaCnpj != null) {
      params = params.append('cnpj', this.empresaCnpj);
    }
    this.service.taxasTermos(params, (response) => {

      this.hasVarejoAccepted = response;

      //busca saldos disponíveis
      this.searchBalances();

    }, (error) => {
      this.notifications.error(error.response.msgRetorno);
    });

    this.buscaBandeiras();
  } // end ngOnInit()

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.myTable);
  }


  clearAll() {
    this.clearImport();

    this.isDisabledSaveButton = true;
    this.taxaEmissao = 0;
    this.valorSolicitado = 0;
    this.resultadoSaldoAgiliza = 0;
    this.msgErroSaldos = "";
    this.listBandeirasSelecionadas = [];

    //Zera saldos consumidos do formuláro (inputs)
    this.importValuesForm = this.formBuilder.group({
      saldoGlobal: 0,
      saldoConta: 0,
      saldoProx30dias: 0,
      saldoParcelado: 0,
      valorImportado: 0,
      valorSolicitado: 0,
      saldoAgiliza: 0,
      emissaoCartao: 'N'
    });
  }

  clearImport() {
    //Limpa informações do arquivo de importação
    this.rowData = [];
    this.columnData = [];
    this.valorImportado = 0;
    this.isValidImportCsv = false;
    this.showMsgErroImport = false;
    this.fileInput.nativeElement.value = null;
    this.fileLabel.nativeElement.innerText = '';
  }

  searchBalances() {
    //busca saldos disponíveis
    this.spinnerService.show();
    let params = new HttpParams();
    if (this.hasVarejoAccepted) {
      params = params.append('isReusoCorporativo', 'true');
    }

    this.service.buscarSaldoRecebiveis(null, (res) => {
      this.saldoProx30diasDisp = res.saldo30dias != null ? res.saldo30dias : 0;
      this.saldoParceladoDisp = res.saldoMaior30dias != null ? res.saldoMaior30dias : 0;
      this.resultadoSaldoAgiliza = Number(this.saldoProx30diasDisp) + Number(this.saldoParceladoDisp);

    }, ()=>{
      this.spinnerService.hide();
    });

    this.service.buscaSaldoGlobal(params, (response) => {
      this.saldoGlobalDisp = response.saldoAtual;
      this.saldoContaDisp = response.saldoContaCorrente;
      this.percMaximoReuso = response.percMaximoReuso;

      //preenche produto selecionado
      this.fillProductCard();

    }, ()=>{
      this.saldoGlobalDisp = 0;
      this.saldoContaDisp = 0;
      this.percMaximoReuso = 0;

      this.fillProductCard();

      this.spinnerService.hide();
    });
  } // end searchBalances()

  fillProductCard() {
    this.commomService.buscaProdutos().subscribe(response => {

      const listProdutos: any = response;
      this.isPagamento = false;

      for (let i = 0; i < listProdutos.length; i++) {
        if (listProdutos[i].produtoId == this.idProdutoSelected) {
          if (listProdutos[i].produtoDescricao === 'ADIANTA') {
            this.productCardInfo = [{
              'label': listProdutos[i].produtoDescricao,
              'descricao': listProdutos[i].produtoDescricao,
              'saldoAtual': listProdutos[i].limiteGlobalAtual == null ? 0 : listProdutos[i].limiteGlobalAtual,
              'icon': 'far fa-money-bill-alt',
              'type': 'primary', //azul
              'taxaDescricao': 'TARIFA_EMISSAO_USUARIO_CONVENIO_BANDEIRADO',
            }];
          } else if (listProdutos[i].produtoDescricao === 'PAGAMENTO') {
            this.isPagamento = true;
            this.productCardInfo = [{
              'label': listProdutos[i].produtoDescricao,
              'descricao': 'SALARIO',
              'saldoAtual': listProdutos[i].saldoGlobalAtual == null ? 0 : listProdutos[i].saldoGlobalAtual,
              'icon': 'fas fa-coins',
              'type': 'danger', //vermelho
              'taxaDescricao': 'TARIFA_EMISSAO_PLATAFORMA_PAGAMENTOS',
            }];
          } else if (listProdutos[i].produtoDescricao === 'ALIMENTACAO_BANDEIRADO') {
            this.isPagamento = true;
            this.productCardInfo = [{
              'label': 'ALIMENTAÇÃO',
              'descricao': 'ALIMENTACAO_BANDEIRADO',
              'saldoAtual': listProdutos[i].saldoGlobalAtual == null ? 0 : listProdutos[i].saldoGlobalAtual,
              'icon': 'fas fa-address-card',
              'type': 'danger', //vermelho
              'taxaDescricao': 'TARIFA_DE_EMISSAO_DE_CARTAO_ALIMENTACAO',
            }];
          } else if (listProdutos[i].produtoDescricao === 'REFEICAO_BANDEIRADO') {
            this.isPagamento = true;
            this.productCardInfo = [{
              'label': 'REFEIÇÃO',
              'descricao': 'REFEICAO_BANDEIRADO',
              'saldoAtual': listProdutos[i].saldoGlobalAtual == null ? 0 : listProdutos[i].saldoGlobalAtual,
              icon: 'fas fa-id-card',
              type: 'info',
              'taxaDescricao': 'TARIFA_DE_EMISSAO_DE_CARTAO_REFEICAO',
            }];
          } else if (listProdutos[i].produtoDescricao === 'FLEXIVEL') {
            this.isPagamento = true;
            this.productCardInfo = [{
              'label': 'FLEXÍVEL',
              'descricao': 'FLEXIVEL',
              'saldoAtual': listProdutos[i].saldoGlobalAtual == null ? 0 : listProdutos[i].saldoGlobalAtual,
              'icon': 'fas fa-money-check',
              'type': 'info',
            }];
          }
        }
      }
      //Monta o card
      this.exibeSaldos = this.isPagamento && this.hasVarejoAccepted;

      if (this.exibeSaldos) {
        this.isDisabledSaveButton = true;
        //calcula saldos
        this.calculateBalances();
      }

      this.spinnerService.hide();  //fecha após carregar informações    

    }, (error) => {
      this.spinnerService.hide();
      this.notifications.error('Não foi possível carregar as informações de produto.');
    });

  }// end fillProductCard()

  calculateBalances() {
    //busca Taxas Reuso
    this.service.buscarTaxaAgiliza(null, (response) => {
      this.tarAgiliza = response;
    }, null);

  } // end calculateBalances()


  csvExport() {
    this.exportCsvService.exportCsv(this.modeloImportacao, null, ';', 'Modelo');
  }

  csvImport(dataCsv: any) {

    this.spinnerService.show();
    this.rowData = [];
    this.showMsgErroImport = false;
    this.msgErroSaldos = "";

    if (this.importValuesForm.value.emissaoCartao == 'S') {

      this.valorImportado = 0;
      this.isValidImportCsv = true;

      this.importCsvService.validCsvStructure(dataCsv, ';').subscribe(validStructure => {

        if (!validStructure.isValid) {
          this.clearImport();
          this.spinnerService.hide();
          this.notifications.error('Arquivo de importação inválido. Verifique a quantidade de campos na(s) linha(s):<br/>' + validStructure.linesErr);
        } else {
          this.importCsvService.csvToJsonAll(dataCsv, ';').subscribe(dataJson => {
            this.csvCallback(dataJson);

            dataJson.data.map(data => {
              this.validateDadosCsv(data);
            });

            if (this.exibeSaldos == true) {
              //verifica saldos disponíveis para habilitar inputs
              document.getElementById('saldoGlobal').removeAttribute('disabled');
              document.getElementById('saldoConta').removeAttribute('disabled');
              document.getElementById('saldoAgiliza').removeAttribute('disabled');

              if (this.saldoGlobalDisp == 0) {
                document.getElementById('saldoGlobal').setAttribute('disabled', 'true');
                document.getElementById('saldoGlobal').setAttribute('placeholder', '');
              }
              if (this.saldoContaDisp == 0) {
                document.getElementById('saldoConta').setAttribute('disabled', 'true');
                document.getElementById('saldoConta').setAttribute('placeholder', '');
              }
              if (this.resultadoSaldoAgiliza == 0) {
                document.getElementById('saldoAgiliza').setAttribute('disabled', 'true');
                document.getElementById('saldoAgiliza').setAttribute('placeholder', '');
              }

            }

          });
        }
      });

      if (this.idProduct == '8' || this.idProduct == '9' || this.idProduct == '10') {
        this.check = true
        this.calcEmitFirstLabelCopy(this.listBandeiras);
        this.isDisabledSaveButton = false;
      }

    } else {
      this.importCsvService.csvToJsonAll(dataCsv, ';').subscribe(dataJson => {
        this.csvCallback(dataJson);
        dataJson.data.map(data => {
          this.validateDadosCsv(data);
        });

        if (this.showMsgErroImport == true) {
          this.isDisabledSaveButton = true;
        } else {
          this.isDisabledSaveButton = false;
        }

      });
    }
  } // end csvImport()

  csvCallback(csvJsonData: any) {
    if (csvJsonData.data.length != null && csvJsonData.data.length > 0) {
      this.fileLabel.nativeElement.innerText = csvJsonData.fileName;

      for (let i = 0; i < csvJsonData.data.length; i++) {
        //Valida para exibir formatado na grid
        let cpfCsv = csvJsonData.data[i].cpf;
        if (CPFValidator.isValidCPF(cpfCsv)) {
          csvJsonData.data[i].cpf = CPFValidator.getFormattedCpf(cpfCsv);
        }
        let phoneCsv = csvJsonData.data[i].telefone_celular;
        if (PhoneValidator.isValidPhone(phoneCsv)) {
          csvJsonData.data[i].telefone_celular = PhoneValidator.getFormattedPhone(phoneCsv);
        }
      }

      //Carrega grid
      const tableData: Array<any> = csvJsonData.data;
      this.rowData = Object.assign([], tableData);
      this.columnData = Object.keys(tableData[0]).map((column) => {
        return { prop: column, name: column.replace("_", " ").toUpperCase() };
      });

      setTimeout(() => {
        this.myTable.recalculate();

        //calcula o custo da importação
        this.expenseCalculator();

        this.spinnerService.hide();  //fecha após carregar arquivo
      }, 10);

    } else {
      this.clearImport();
      this.spinnerService.hide();
      this.notifications.error('Arquivo sem dados para a importação.');
    }
  } // end csvCallback()

  expenseCalculator() {
    //calcula o custo da importação
    this.valorImportado = Number(this.rowData.length * this.taxaEmissao);
    this.importValuesForm.controls['valorImportado'].setValue(this.valorImportado);

    if (!this.exibeSaldos) {
      this.importValuesForm.controls['saldoGlobal'].setValue(this.valorImportado);
      this.validatesConsumedBalances(this.importValuesForm.value);
    }
  }

  validatesConsumedBalances(valuesForm) {
    //Valida os saldos consumidos (inputs)
    this.msgErroSaldos = "";
    //Calcula total solicitado
    this.valorSolicitado = Number(valuesForm.saldoGlobal) + Number(valuesForm.saldoConta)
      + Number(valuesForm.saldoProx30dias) + Number(valuesForm.saldoParcelado)
      + Number(valuesForm.saldoAgiliza);
    this.importValuesForm.controls['valorSolicitado'].setValue(this.valorSolicitado);

    //Valida disponibilidade
    if (valuesForm.saldoGlobal > this.saldoGlobalDisp) {
      this.msgErroSaldos = 'Saldo Global solicitado é maior que o disponível.';
      this.notifications.warn(this.msgErroSaldos);

    } else if (valuesForm.saldoConta > this.saldoContaDisp) {
      this.msgErroSaldos = 'Saldo Conta Corrente solicitado é maior que o disponível.';
      this.notifications.warn(this.msgErroSaldos);

    } else if (valuesForm.saldoProx30dias > this.resultadoSaldoAgiliza) {
      this.msgErroSaldos = 'Saldo Próximos 30 dias solicitado é maior que o disponível.';
      this.notifications.warn(this.msgErroSaldos);

    } else if (valuesForm.saldoParcelado > this.resultadoSaldoAgiliza) {
      this.msgErroSaldos = 'Saldo Parcelado solicitado é maior que o disponível.';
      this.notifications.warn(this.msgErroSaldos);
    } else if (valuesForm.saldoAgiliza > this.resultadoSaldoAgiliza) {
      this.msgErroSaldos = 'Saldo Agilliza solicitado é maior que o disponível.';
      this.notifications.warn(this.msgErroSaldos);
    }


    if (this.msgErroSaldos.length == 0) {

      if (this.valorSolicitado == this.valorImportado) {
        this.isDisabledSaveButton = false;
      } else {
        this.isDisabledSaveButton = true;
        this.msgErroSaldos = 'Valor total solicitado é diferente do Valor importado, ou seja, do custo da 1ª Via.';
        this.notifications.warn(this.msgErroSaldos);
      }

    }

    if (this.listBandeirasSelecionadas == null || this.listBandeirasSelecionadas.length == 0) {

      if (this.idProduct == '8' || this.idProduct == '9' || this.idProduct == '10') {
        this.isDisabledSaveButton = false;
      }

    }
  }


  saveEmployeeImport() {

    let valuesForm = this.importValuesForm.value

    if (this.idProduct == '8' || this.idProduct == '9' || this.idProduct == '10') {

      this.listBandeirasSelecionadas = this.listBandeiras;

    }

    if (this.valorImportado > this.productCardInfo[0].saldoAtual) {
      this.notifications.error('Não é possível importar devido o custo da taxa de emissão' +
        ' ser maior que o saldo para o produto: R$ ' + this.productCardInfo[0].saldoAtual);
      throw new Error(`Balance unavailable from ${this.productCardInfo[0].descricao}`);
    }

    this.spinnerService.show();

    const emplyeeRows: Array<any> = this.rowData.map(data => {
      return {
        nome: data.nome.trim(),
        cpf: CPFValidator.getCPFNumbers(data.cpf),
        cargo: data.cargo.trim(),
        matricula: data.matricula.trim(),
        dataAdmissao: String(data.data_admissao).trim().split('/').join('-'),
        telefoneCelular: PhoneValidator.getPhoneNumbers(data.telefone_celular),
        email: data.email.trim(),
        salario: String(data.salario).trim().replace('.', '').replace(',', '.'),
        bandeiras: this.listBandeirasSelecionadas,
        produto: this.productCardInfo[0].descricao,
        nomeSocial: data.nome,
        nomeMae: data.nome,
        dataNascimento: String(data.data_admissao).split('/').join('-'),
      };
    });

    const register: any = {
      registrosImportacao: emplyeeRows,
      valorGlobal: valuesForm.saldoGlobal,
      valorContaCorrente: valuesForm.saldoConta,
      valorRecebiveis: valuesForm.saldoAgiliza,
      valorRecebiveis30dias: valuesForm.saldoProx30dias,
      valorRecebiveisParcelado: valuesForm.saldoParcelado,
      solicitacaoAutomaticaCartao: valuesForm.emissaoCartao,
      bandeiras: this.listBandeiras,
    };

    this.service.saveEmployeeImport(register, (response) => {
      console.log("response: ", response.validation)
      if (response.success === false) {
        this.spinnerService.hide();
        this.notifications.error(response.validation[0].cpf +" "+ response.validation[0].message);
      }else{      
        this.clearAll();
        this.searchBalances();
        this.spinnerService.hide();
        this.notifications.success('Processo de importação realizado com sucesso!');
      }
    }, (error) => {
      this.clearAll();
      this.searchBalances();
      this.spinnerService.hide();
      this.notifications.error(error.message);
    });

  }

  getCellClass = ({ row, column, value }): any => {
    return {
      'cell-invalid': !this.validateEmployee(column.prop, value)
    };
  }

  validateEmployee(column, value) {

    if (column == "cpf") {
      if (!CPFValidator.isValidCPF(value)) {
        return false;
      }

    } else if (column == "data_admissao") {
      if (!DateValidator.isValidDate(value)) {
        return false;
      }

    } else if (column == "telefone_celular") {
      if (!PhoneValidator.isValidPhone(value)) {
        return false;
      }

    } else if (column == "email") {
      if (!EmailValidator.isValidEmail(value)) {
        return false;
      }

    } else if (column == "salario") {
      if (!NumberValidator.isValidComma2Decimal(value)) {
        return false;
      }

    } else if (value == null || value.trim().length < 1) {
      return false;
    }

    return true;
  } // end validateEmployee()

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  cancel() {
    this.clearAll();
    this.searchBalances();
  }

  showProximosInfo() {
    this.dialogService.open(ModalPrimeiraViaComponent, {
      context: {
        nome: 'saldoProx30dias',
      },
    });
  }

  showParceladoInfo() {
    this.dialogService.open(ModalPrimeiraViaComponent, {
      context: {
        nome: 'saldoParcelado',
      },
    });
  }

  saldoAgiliza() {

    this.dialogService.open(ModalPrimeiraViaComponent, {
      context: {
        nome: 'saldoAgiliza',
      },
    });
  }

  buscaBandeiras() {

    this.service.buscaBandeiras(this.empresaCnpj, this.idProdutoSelected, null, (response) => {

      this.listBandeiras = response;

    }, (error) => {
      this.notifications.error(error.message);
    });
  }

  selecionarBandeira(bandeira: any, isSelecionado: any) {

    if (isSelecionado) {
      let listBandeirasSelecionadasFilter: Array<any> =
        this.listBandeirasSelecionadas.filter(bandeiraFilter => bandeiraFilter.id === bandeira.id);
      if (listBandeirasSelecionadasFilter.length == 0) {
        this.listBandeirasSelecionadas.push(bandeira);
      }
    } else {
      this.listBandeirasSelecionadas =
        this.listBandeirasSelecionadas.filter(bandeiraFilter => bandeiraFilter.id !== bandeira.id);
    }

    this.calcEmitFirstLabelCopy(this.listBandeirasSelecionadas);
  }

  calcEmitFirstLabelCopy(listBandeirasSelecionadas: Array<any>) {

    let produtoId = this.idProdutoSelected;
    let listBandeiraId: Array<any> = listBandeirasSelecionadas.map((bandeira) => bandeira.id);
    let listBandeiraIdString: string = '';

    for (let bandeiraId of listBandeiraId) {
      listBandeiraIdString = listBandeiraIdString + bandeiraId + ','
    }

    listBandeiraId.map(bandeiraId => listBandeiraIdString + bandeiraId + ',');
    listBandeiraIdString = listBandeiraIdString.slice(0, -1);

    let params = new HttpParams();
    params = params.append('produtoId', produtoId);
    params = params.append('listBandeiraId', listBandeiraIdString);
    this.service.ratesEmitFirstLabelCopy(params,
      (response) => {
        if (response.length == 0) {
          this.taxaEmissao = 0;
        } else {
          this.taxaEmissao = response.reduce((prevVal, historico) => {
            return prevVal + historico.valor;
          }, 0);
        }

        this.expenseCalculator();

      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  validateDadosCsv(value) {

    if (!CPFValidator.isValidCPF(value.cpf)) {
      this.isValidImportCsv = false;
      this.showMsgErroImport = true;
      return false;
    }
    if (!DateValidator.isValidDate(value.data_admissao)) {
      this.isValidImportCsv = false;
      this.showMsgErroImport = true;
      return false;
    }
    if (!PhoneValidator.isValidPhone(value.telefone_celular)) {
      this.isValidImportCsv = false;
      this.showMsgErroImport = true;
      return false;
    }
    if (!EmailValidator.isValidEmail(value.email)) {
      this.isValidImportCsv = false;
      this.showMsgErroImport = true;
      return false;
    }
    if (!NumberValidator.isValidComma2Decimal(value.salario)) {
      this.isValidImportCsv = false;
      this.showMsgErroImport = true;
      return false;
    }

    return true;
  }

  openModal() {
    this.dialogService.open(ModalEmissaoCartaoComponent, {
      closeOnBackdropClick: false,
      closeOnEsc: false,
      context: {
        emitirCartao: this.importValuesForm.value.emissaoCartao,
      },
    }).onClose.subscribe(validacao => this.habillitarBotao(validacao));
  }

  habillitarBotao(value: boolean) {
    if ((value == false) || (value == undefined)) {
      this.isDisabledSaveButton = true;
      this.notifications.warn('Importação cancelada.');
      this.rowData = [];
      this.fileInput.nativeElement.value = null;
      this.fileLabel.nativeElement.innerText = '';
      this.valorImportado = 0;
      this.isValidImportCsv = false;
    } else if (value == true) {
      this.saveEmployeeImport();
    }
  }

  limparGrid() {
    this.isDisabledSaveButton = true
    if (this.rowData.length == 1) {
      this.rowData = [];
      this.fileInput.nativeElement.value = '';
      this.fileLabel.nativeElement.innerText = '';
      this.valorImportado = 0;
      this.isValidImportCsv = false;
    }

  }


  private verificarMigracaoRollout() {
    this.commomService.isProdutoMigrado().subscribe(isMigrated => {
      this.isProdutoMigrado = isMigrated;
    });
  }
}
